import type { ShouldRevalidateFunctionArgs } from 'react-router'

export const shouldRevalidateRoot = ({
  currentUrl,
  nextUrl,
  formMethod,
  defaultShouldRevalidate,
}: ShouldRevalidateFunctionArgs) => {
  const isSearchOnlyNavigation =
    formMethod == null && currentUrl.pathname === nextUrl.pathname && currentUrl.search !== nextUrl.search

  return isSearchOnlyNavigation ? false : defaultShouldRevalidate
}
